import React from "react";
import  { useEffect } from "react";
import { Box, Typography, Container, useMediaQuery,Grid } from "@mui/material";
import Footer from "./Footer";

import { motion} from "framer-motion";


const BigData = () => {
    const isMobile = useMediaQuery("(max-width: 768px)");
  //  const sectionRef = useRef(null);
  //  const isInView = useInView(sectionRef, { triggerOnce: false, threshold: 0.2 });


     useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top when component loads
      },[]);

  const bulletPoints = [
    "Ensure a seamless customer experience across products, channels, and lifecycle",
    "Improve customer retention",
    
    "Launch successful loyalty programs",
    "Increase profitability by enhanced customer targeting through cross/up sell",
    "Develop new products",
    "Enhance customer lifetime value",
  ];


  

  const boxColors = ["#1F6788", "#1F6788", "#1F6788", "#1F6788", "#1F6788", "#1F6788"]; 
   


  
  
  return (
    <>
      {/* First Section - Background Image */}
      <Box
  sx={{
    position: "relative",
    width: "100%",
    minHeight: "100vh", // Use minHeight instead of fixed height
    backgroundImage: `url("/image/bigdata1.jpg")`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    color: "white",
    overflow: "hidden", // Prevents content from spilling over
  }}
>
  {/* Dark overlay for readability */}
  <Box
    sx={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    }}
  />

  {/* Content Box */}
  <Box
    sx={{
      position: "relative",
      maxWidth: "700px",
      marginLeft: { xs: "3%", md: "8%" },
      marginTop: { xs: "15%", md: "10%" }, // Reduce margin to avoid overflow
      zIndex: 1,
      padding: 4,
      
    }}
  >
    <Typography 
      variant="h3" 
      sx={{ 
        fontWeight: "bold", 
        mb: 2, 
        fontSize: { xs: "28px", md: "42px" }, // Reduce size slightly for better fit
      }}
    >
      Big Data Analytics
    </Typography>
    <Typography 
      variant="body1" 
      sx={{ 
        fontSize: { xs: "14px", md: "18px" }, 
        maxWidth: "100%", 
        wordBreak: "break-word", 
        lineHeight: 1.5, 
      }}
    >
      Creating a seamless customer experience in a digital world is a primary challenge that several organizations across the globe are grappling with. Customers today expect personalized service without compromise, and demand their providers to educate and inform them no matter what channel they choose to use. A move to customer centricity hinges on delivering better customer experience across all channels and providing value across the customer experience life cycle. Big Data Analytics is increasingly emerging as a key enabler in helping organizations achieve this. Creating a powerful customer value proposition requires understanding customer behaviour, preferences and needs along with product/service life-cycle and linking these with ongoing operational transactions and past behavior.

    </Typography>
  </Box>
</Box>


      {/* Second Section - Infographic */}
      <Box
      sx={{
        //backgroundImage: `url("/image/bgfull.jpg")`,
        background:"white",
        py: 6,
        px: 2,
        textAlign: "center",
        minHeight: "60vh",
      }}
    >
      <Container maxWidth="md" sx={{ mb: 4 }}>
      <Typography
  variant="h2"
  sx={{
    fontWeight: "bold",
    color: "black",
    fontSize: {
      xs: "1.8rem",  // Small screens (mobile)
      sm: "2.2rem",  // Tablets
      md: "2.5rem",  // Medium screens
      lg: "3rem",    // Large screens
      xl: "3.5rem",  // Extra large screens
    },
    textAlign: "center", // Centers text for better responsiveness
    mt: 2, // Adds margin-top for spacing
  }}
>    How Tech Informatic Solutions Helps
        </Typography>
        <Typography variant="body1" sx={{ lineHeight: 1.6, fontSize: isMobile ? "1rem" : "1.2rem", mt: 2, color: "black" }}>
        Tech Informatic Solutions helps you leverage customer data on purchase patterns, preferences, feedback, wish lists, enquiries etc. to generate customer insights in real time. Our Big Data Analytics Service helps you:
        </Typography>
      </Container>

      <Container maxWidth="lg">
        <Grid container spacing={3} justifyContent="center" alignItems="center">
          <Grid item xs={12} md={4}>
            {bulletPoints.slice(0, 3).map((point, index) => (
              <Box
                key={index}
                sx={{
                  background: `linear-gradient(145deg, ${boxColors[index]}, #000)`,
                  borderRadius: "20px",
                  boxShadow: "10px 10px 20px rgba(0,0,0,0.5)",
                  p: 3,
                  mb: 2,
                  textAlign: "left",
                  display: "flex",
                  alignItems: "center",
                  color: "white",
                  transition: "all 0.3s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.05)",
                  },
                }}
              >
                <Typography variant="body1" sx={{ fontSize: isMobile ? "0.9rem" : "1.2rem", color: "white" ,fontWeight:"bold"}}>
                  {point}
                </Typography>
              </Box>
            ))}
          </Grid>

          <Grid item xs={12} md={4}>
            <Box
              sx={{
                width: isMobile ? "200px" : "250px",
                height: isMobile ? "200px" : "250px",
                borderRadius: "50%",
               background: "radial-gradient(circle, #1F6788,#161623)",
               //  background:"#161623",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "white",
                fontWeight: "bold",
                fontSize: isMobile ? "1.5rem" : "2rem",
                mx: "auto",
                boxShadow: "15px 15px 30px rgba(0,0,0,0.8)",
                transition: "transform 0.3s ease-in-out",
                "&:hover": {
                  transform: "scale(1.1)",
                },
              }}
            >
              <Typography variant="h5" sx={{ fontWeight: "bold", color: "white" }}>
                Big Data Analytics
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            {bulletPoints.slice(3).map((point, index) => (
              <Box
                key={index + 3}
                sx={{
                  background: `linear-gradient(145deg, ${boxColors[index + 3]}, #000)`,
                  borderRadius: "20px",
                  boxShadow: "10px 10px 20px rgba(0,0,0,0.5)",
                  p: 3,
                  mb: 2,
                  textAlign: "left",
                  display: "flex",
                  alignItems: "center",
                  color: "white",
                  transition: "all 0.3s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.05)",
                  },
                }}
              >
                <Typography variant="body1" sx={{ fontSize: isMobile ? "0.9rem" : "1.2rem", color: "white" ,fontWeight:"bold"}}>
                  {point}
                </Typography>
                
              </Box>
            ))}
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="md" sx={{ mb: 4 }}>
        
        <Typography variant="body1" sx={{ lineHeight: 1.6, fontSize: isMobile ? "1rem" : "1.2rem", mt: 2, color: "black" }}>
        Our Big Data Analytics Service puts in place data, processes, analytics tools and visualizations, coherently, by
 enabling faster time to insights, and enhancing the quality and reliability of insights through exploratory and
 self-learning models. We help you improve business outcomes through data driven decisions.   </Typography>
      </Container>
    </Box>
    


{/* 4th Section  */}
<Box
  sx={{
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    alignItems: "center",
    justifyContent: "center",
    py: 6,
    px: 2,
    minHeight: "60vh",
    backgroundImage: `url("/image/bgfull.jpg")`,
  }}
>
  {/* Left Side Content - 1/4th Space */}
  <Box
    sx={{
      flex: 1,
      px: 2,
      textAlign: isMobile ? "center" : "left",
      maxWidth: isMobile ? "100%" : "25%",
      mb: isMobile ? 4 : 0, // Adds space below in mobile view only
    }}
  >
    <Typography variant="h4" fontWeight="bold" color="black">
      Industry-Focused Use Cases:
    </Typography>
    <Typography
      variant="body1"
      sx={{
        lineHeight: 1.4,
        fontSize: isMobile ? "1rem" : "1.2rem",
        mt: 2,
        fontWeight: "bold",
        color: "black",
      }}
    >
      Actionable Insights for Financial Services (Industry applicability):
      Insurance, Wealth Management, and Retail Banking. This solution spans
      multiple financial data domains, offering components on data integration,
      data management, and a set of analytical applications (models, rules, KPI,
      and dashboards) in areas of customer retention, segmentation, risk
      analysis, voice analytics, pricing, and cross-sell/up-sell. It helps
      improve customer centricity and reduces time to market.
    </Typography>
  </Box>

  {/* Center Image - 2/4th Space */}
  <Box
    sx={{
      flex: 2,
      display: "flex",
      justifyContent: "center",
      px: 2,
      maxWidth: isMobile ? "100%" : "50%",
      mb: isMobile ? 14: 0, // Adds space below in mobile view only
    }}
  >
    <img
      src="/image/fd.png"
      alt="Industry Insights"
      style={{
        width: isMobile ? "95%" : "100%",
        maxWidth: isMobile ? "500px" : "800px",
        height: isMobile ? "auto" : "100%",
        maxHeight: isMobile ? "450px" : "600px",
        objectFit: "contain",
      }}
    />
  </Box>

  {/* Right Side Content - 1/4th Space */}
  <Box
    sx={{
      flex: 1,
      px: 2,
      textAlign: isMobile ? "center" : "left",
      maxWidth: isMobile ? "100%" : "25%",
     // mb: isMobile ? 4 : 0, // Adds space below in mobile view only
      mt: -8,
    }}
  >
    <Typography variant="h4" fontWeight="bold" color="black">
      Actionable Insights for Retail:
    </Typography>
    <Typography
      variant="body1"
     sx={{
        lineHeight: 1.4,
        fontSize: isMobile ? "1rem" : "1.2rem",
        mt: 2,
        fontWeight: "bold",
        color: "black",
      }}
    >
      Applicability for Retail and CPG: This is an integrated set of analytical
      applications for retailers embarking on integrated multi-channel
      marketing, real-time offerings, or new market entry. The solution has
      unique features such as actionable insights on lead generation using
      third-party data along with CRM data (using universal persona technique),
      and attrition drivers using open-source data.
    </Typography>
  </Box>
</Box>


  {/* Third Section  */}

  <Box
      sx={{
       backgroundColor: "white",
       //backgroundImage: `url("/image/bgfull.jpg")`,
        py: 4,
        px: 2,
        textAlign: "center",
        minHeight: "80vh",
      }}
    >
      {/* Title Section */}
      <Container maxWidth="md" sx={{ mb: 4 }}>
        <Typography
          variant="h2"
          sx={{
            fontWeight: "bold",
            color: "black",
            fontSize: { xs: "1.8rem", sm: "2.2rem", md: "2.5rem", lg: "3rem" },
            textAlign: "center",
            mt: 2,
          }}
        >
          Differentiating features of our offering include
        </Typography>
        <Typography
          sx={{
            lineHeight: 1.6,
            fontSize: { xs: "1rem", md: "1.2rem" },
            mt: 2,
            color: "black",
          }}
        >
          The underlying core concept of our service is the use of data events that produce semantic information based on
          rules/patterns for identifying events of significance. The data layer is the engine driving this Analytics platform.
        </Typography>
      </Container>

      {/* Features Section */}
      <Container maxWidth="lg">
        <Grid container spacing={3} sx={{ mt: 4 }}>
          {[
            {
              bgImage: "/image/f3.jpeg", // Replace with actual image path
              points: [
                "Cloud-based Integrated Data and Analytics Platform",
                "Analytics based on exploratory and Data Discovery approaches",
              ],
            },
            {
              bgImage: "/image/f2.jpeg", // Replace with actual image path
              points: [
                "Real-time analytical information and predictive/prescriptive models for better decision making",
                "Builds on a machine learning mechanism that understands the behavioral aspects of decision making",
              ],
            },
          ].map((feature, index) => (
            <Grid item xs={12} md={6} key={index}>
              <motion.div
                whileHover={{ y: -5 }} // Jump effect on hover
                transition={{ type: "spring", stiffness: 200, damping: 10 }}
              >
                 <Box
                  sx={{
                    position: "relative",
                    backgroundImage: `url(${feature.bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "12px",
                    p: 4,
                    minHeight: "250px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between", // ✅ Ensures equal spacing
                    overflow: "hidden",
                    textAlign: "left", // ✅ Left-aligned text
                  }}
                >
                  {/* Dark Overlay for Better Visibility */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.6)", // Reduced brightness
                      zIndex: 1,
                    }}
                  />

                  {/* Bullet Points - Always Visible */}
                  <Box
                    sx={{
                      position: "relative",
                      zIndex: 2,
                      display: "flex",
                      flexDirection: "column",
                      gap: "30px", // ✅ Creates space between two bullet points
                      minHeight: "100%", // ✅ Ensures equal height
                      mt:6,
                    }}
                  >
                    {feature.points.map((point, i) => (
                      <Box
                        key={i}
                        sx={{
                          display: "flex",
                          alignItems: "flex-start", // ✅ Aligns bullet with text properly
                          gap: "8px",
                          color: "white",
                          minHeight: "50px", // ✅ Ensures each bullet aligns properly
                        }}
                      >
                        <Typography
                          component="span"
                          sx={{
                            fontSize: "1.5rem",
                            lineHeight: "1.5rem", // ✅ Ensures bullet stays aligned
                          }}
                        >
                          ✅
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: "1rem", md: "1.2rem" },
                            lineHeight: "1.5rem", // ✅ Ensures text stays in line
                          }}
                        >
                          {point}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    

</Box>

    







 
   {/* 2nd Title Section with Background Image */}
<Box
  sx={{
    position: "relative",
   // backgroundImage: `url("/image/grey9.jpg")`, // Replace with your actual image path
   backgroundColor:"#9FAAB0",
    backgroundSize: "cover",
    backgroundPosition: "center",
   // backgroundAttachment: "fixed", // Optional: Creates a parallax effect
    minHeight: "80vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    color: "white", // Ensures text is visible
    px: 2,
    py: 6,
  }}
>
  <Container maxWidth="md" sx={{ mb: 4 }}>
    <Typography
      variant="h2"
      sx={{
        fontWeight: "bold",
        color: "black", // Ensure text is readable
        fontSize: { xs: "1.8rem", sm: "2.2rem", md: "2.5rem", lg: "3rem" },
        textAlign: "center",
        mt: 8,
      }}
    >
      Following is a sequential detail of the Big Data Analytics platform
    </Typography>
  </Container>






  {/* Features Section - 2nd Section */}
<Container maxWidth="lg">
  <Grid
    container
    spacing={3} // ✅ Keeps space between boxes in larger screens
    gap={{ xs: 3, md: 0 }} // ✅ Adds spacing ONLY for mobile view
    
    sx={{ mt: 4, mb: 14, alignItems: "stretch" }} // ✅ Ensures all boxes stretch equally
  >
    {[
      {
        bgImage: "/image/f4.jpg",
        point:
          "Apart from internal data sources, our platform works with external data sources to build a 720-degree view of the customer and design tailored communications and proactive offers.",
      },
      {
        bgImage: "/image/f6.jpg",
        point:
          "Our Decision Management Hub interprets large volumes of incoming data, including real-time data streams. Mapping these insights over a 720-degree view of your customer helps identify and build unique customer experiences.",
      },
      {
        bgImage: "/image/f8.jpg",
        point:
          "Upon developing targeted campaigns and communication strategies for engaging your customers, we help you identify the best channel to reach them via email, direct call, mobile SMS, etc. An automated and streamlined workflow for executing these actions through digital marketing platforms is a key feature of this platform.",
      },
    ].map((feature, index) => (
      <Grid
        item
        xs={12}
        sm={6}
        md={4} // ✅ 3 Boxes in a row in desktop
        key={index}
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1, // ✅ Ensures equal height in desktop
          mb: { xs: 4, md: 0 }, // ✅ Adds space ONLY in mobile view
        }}
      >
        <motion.div
          whileHover={{ y: -5 }}
          transition={{ type: "spring", stiffness: 200, damping: 10 }}
          style={{ width: "100%", height: "100%" }} // ✅ Maintains equal height
        >
          <Box
            sx={{
              position: "relative",
              backgroundImage: `url(${feature.bgImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              borderRadius: "12px",
              p: 4,
              minHeight: "100%", // ✅ Ensures all boxes match tallest one
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
              textAlign: "center",
              flex: 1, // ✅ Forces equal height
            }}
          >
            {/* Dark Overlay for Better Visibility */}
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                zIndex: 1,
              }}
            />

            {/* Single Bullet Point in Each Box */}
            <Box
              sx={{
                position: "relative",
                zIndex: 2,
                display: "flex",
                alignItems: "center",
                gap: "10px",
                color: "white",
                textAlign: "left",
              }}
            >
              <Typography
                variant="body1"
                sx={{ fontSize: { xs: "1rem", md: "1.2rem" }, lineHeight: "1.8" }}
              >
                {feature.point}
              </Typography>
            </Box>
          </Box>
        </motion.div>
      </Grid>
    ))}
  </Grid>
</Container>





</Box>


    <Footer/>
    </>
  );
};

export default BigData;
